import { z } from 'zod';
/**
 * Lời giải thích cho điểm rủi ro trễ — APM-AI-r (`plan-ai-features.md` mục 3).
 *
 * ## Model KHÔNG chấm điểm
 *
 * Điểm và ba lý do đứng đầu là của hệ thống (`APM-AI-q`, hàm thuần). Skill này
 * chỉ **viết lời** cho chúng và đề xuất việc nên làm tuần này. Vì sao chia vậy:
 * một con số do model chấm thì mỗi lần hỏi ra một số khác, không so được giữa
 * hai dự án, và PM không cãi lại được. Còn một câu văn thì đọc xong là biết nó
 * có nghĩa hay không.
 */
export const DelayRiskAction = z.object({
    text: z.string().min(1).max(300),
    /** Việc cụ thể mà hành động này đụng tới; rỗng khi nó là việc của cả đội. */
    relatedTaskIds: z.array(z.uuid()).max(10),
});
export const DelayRiskExplanation = z.object({
    /** Điểm chép nguyên từ `read_project_health` — để giao diện không phải hỏi hai chỗ. */
    score: z.number().int().min(0).max(100),
    /** Vài câu: dự án đang gặp gì, theo đúng ba lý do hệ thống đưa ra. */
    narrative: z.string().min(1).max(2_000),
    /** Ba việc nên làm tuần này. Rỗng khi điểm thấp — không việc gì phải bịa. */
    actions: z.array(DelayRiskAction).max(3),
});
//# sourceMappingURL=ai-delay-risk.js.map